import type { FaireProductEntity } from "../../entity_types/product";

export const p_28cqzetbbq: FaireProductEntity = {
  token: "p_28cqzetbbq",
  type: "product",
  name: "Stankonia Coffee",
  brandToken: "b_8rgv5suw2a",
  brandName: "Portrait Coffee",
  imageUrl:
    "https://cdn.faire.com/fastly/b9f283d51fd7f04ad4637298f94633715f63dc77b3f215d3d2e75a2c7732eee3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c7c26fa5d3a7317755442b221137838002531243655f9d856da4d4c7c554beb1.jpeg",
    "https://cdn.faire.com/fastly/ff0ff7ebf2c71187207dd6b8bc2c6ffd220447606205cb6929cdc847ddc14da5.png",
    "https://cdn.faire.com/fastly/aeddfc0c0b243e6687cdbc2f59fa38f2175d845b1dbea4b3334d398fcc012267.png",
  ],
  priceDollars: 43.8,
  description:
    "A limited-edition tribute to ATL's most iconic album.\n\nOutkast and Portrait Coffee celebrate 25 years of Stankonia with a limited-edition coffee inspired by the album's funk, futurism, and Atlanta roots. Bright, layered, and full of rhythm, Stankonia Coffee bridges music and coffee culture, honoring Outkast's legacy of innovation while continuing Portrait's mission to pour a new narrative in specialty coffee.\n\nOrigin: Rwanda & Colombia\nProcess: Experimental Natural & Washed\nTasting Notes: Green Apple, Strawberry, Brown Sugar\nRoast Level: Medium\nRecommended Brew: Drip, Pour-Over, or Espresso\n\nWhole bean or ground, roasted to order in Atlanta.\n",
  tags: [],
  msrpDollars: 73,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:14.044Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
